<div class="payment-page-wrapper">
  <header class="payment-page-header">
    <div class="header-brand">
      <img
        class="brand-logo"
        [src]="branding.logoPortalMedico()"
        [alt]="branding.companyName()"
        (error)="branding.useDefaultLogo($event)"
      />
    </div>
    <div class="header-secure">
      <i class="pi pi-lock"></i>
      <span>{{ 'payment_secure' | translateText }}</span>
    </div>
  </header>

  <main class="payment-page-main">
    @if (loading()) {
      <div class="page-loading">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
    }

    @if (!loading() && error()) {
      <div class="page-error">
        <i class="pi pi-exclamation-circle"></i>
        <h3>{{ 'payment_error' | translateText }}</h3>
        <p>{{ error() }}</p>
      </div>
    }

    @if (!loading() && !error() && alreadyPaid) {
      <div class="page-already-paid">
        <i class="pi pi-check-circle"></i>
        <h3>{{ 'payment_already_paid' | translateText }}</h3>
      </div>
    }

    @if (!loading() && !error() && !alreadyPaid && consultationId()) {
      <div class="payment-page-content">
        <div class="payment-page-info">
          <h2>{{ 'payment_confirm_consultation' | translateText }}</h2>
          <p class="page-subtitle">{{ 'payment_complete_to_book' | translateText }}</p>
          @if (formattedAmount) {
            <div class="amount-display">
              <span class="amount-label">{{ 'payment_status' | translateText }}</span>
              <span class="amount-value">{{ formattedAmount }}</span>
            </div>
          }
        </div>

        <app-payment [consultationId]="consultationId()!" [onSuccess]="onPaymentSuccess.bind(this)"></app-payment>
      </div>
    }
  </main>
</div>
